import { paymentService } from "./paymentService";


export default {
  getFingerprint,
  authorizeCS,
  tdsEnrol,
  tdsValidate,
  makeVoucherPayment,
  makeOmanDebitPayment,
  makeAGPayment,
  holdBooking,
  unHoldBooking,
  makeFTPayment,
  makeCashPayment,
  checkOmanDebitPayment,
  getPaymentTotal,
  convertCurrency,
  getPaymentMethods,
  getMadaPaymentParams,
  getKnetPaymentParams,
  getSmartPayParams,
  getWalletPaymentParams,
  getSmartPayMerchantHostedParams
};

function getFingerprint(eppSelected) {
  return () => paymentService.getFingerprint(eppSelected);
}

function authorizeCS(details) {
  return () => paymentService.authorizeCS(details);
}

function tdsEnrol(details, cardinalEventData) {
  return () => paymentService.check3DSEntrollment(details, cardinalEventData);
}
function tdsValidate(details) {
  return () => paymentService.check3DSValidation(details);
}

function makeVoucherPayment(details) {
  return () => paymentService.makeVoucherPayment(details);
}

function makeOmanDebitPayment() {
  return () => paymentService.makeOmanDebitPayment();
}

function makeAGPayment() {
  return () => paymentService.makeAGPayment();
}

function holdBooking() {
  return () => paymentService.holdBooking();
}

function unHoldBooking() {
  return () => paymentService.unHoldBooking();
}

function makeFTPayment() {
  return () => paymentService.makeFTPayment();
}

function makeCashPayment(request) {
  return () => paymentService.makeCashPayment(request);
}

function checkOmanDebitPayment(reference) {
  return () => paymentService.checkOmanDebitPayment(reference);
}

function getPaymentTotal(methodCode) {
  return () => paymentService.getPaymentTotal(methodCode);
}

function convertCurrency(data) {
  return () => paymentService.convertCurrency(data);
}

function getPaymentMethods() {
  return () => paymentService.getPaymentMethods();
}

function getMadaPaymentParams() {
  return () => paymentService.getMadaPaymentParams();
}

function getKnetPaymentParams() {
  return () => paymentService.getKnetPaymentParams();
}

function getSmartPayParams() {
  return () => paymentService.getSmartPayParams();
}

function getWalletPaymentParams() {
  return () => paymentService.getWalletPaymentParams();
}

function getSmartPayMerchantHostedParams(data) {
  return () => paymentService.getSmartPayMerchantHostedParams(data);
}


